module.exports = __webpack_public_path__ + "img/millionpuzzles.50a72eff.png";